<app-layout-servidor
  [logo]="logoEmpresa"
  [iniciais]="iniciaisEmpresa"
  [nome]="nomeEmpresa"
  [agora]="agora"
  [aba]="aba"
  [itens]="itensMenu"
  [mensagem]="mensagem"
  (selecionar)="selecionarAba($event)"
  (sair)="sair()">

  <app-painel-dashboard-servidor
    *ngIf="aba === 'inicio'"
    [identificacao]="identificacao"
    [atalhos]="atalhos"
    (selecionar)="selecionarAba($event)">
  </app-painel-dashboard-servidor>

  <section class="panel p-4" *ngIf="aba === 'comprovante'">
    <div class="mb-3">
      <h2 class="h5 mb-1">Comprovante de Marcações</h2>
      <div class="text-secondary small">{{ identificacao }}</div>
      <div class="text-secondary small">{{ batidas?.rotuloMes || 'Mes vigente' }}<span *ngIf="batidas?.jornada"> · {{ batidas?.jornada }}</span></div>
    </div>

    <div class="table-responsive" *ngIf="batidas?.dias?.length; else semBatidas">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Dia</th>
            <th *ngFor="let coluna of colunas">{{ coluna }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dia of batidas?.dias">
            <td>{{ dia.rotulo }}</td>
            <td *ngFor="let coluna of colunas">
              <ng-container *ngIf="batidaNaColuna(dia, coluna) as batida; else vazio">
                <div>{{ batida.hora }}</div>
                <button type="button" class="btn btn-outline-success btn-sm mt-1" (click)="comprovante(batida)">Comprovante</button>
              </ng-container>
              <ng-template #vazio>—</ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #semBatidas>
      <p class="text-secondary mb-0">Nenhuma batida neste mes.</p>
    </ng-template>
  </section>

  <section class="panel p-4" *ngIf="aba === 'ajuste'">
    <div class="mb-3">
      <h2 class="h5 mb-1">Solicitar inclusão de marcação</h2>
      <div class="text-secondary small">{{ identificacao }}</div>
      <div class="text-secondary small">Todos os campos sao obrigatorios. Depois do deferimento, o horario e gravado na folha oficial.</div>
    </div>

    <form #formAjuste="ngForm" class="row g-3 align-items-end mb-4" (ngSubmit)="pedirAjuste()">
      <div class="col-md-3">
        <label class="form-label" for="dataAjuste">Dia <span class="text-danger">*</span></label>
        <input class="form-control" id="dataAjuste" type="date" name="dataAjuste" [(ngModel)]="dataAjuste" required>
      </div>
      <div class="col-md-2">
        <label class="form-label" for="horaAjuste">Horario <span class="text-danger">*</span></label>
        <input class="form-control" id="horaAjuste" type="time" name="horaAjuste" [(ngModel)]="horaAjuste" step="60" required>
      </div>
      <div class="col-md-2">
        <label class="form-label" for="numeroBatidaAjuste">Batida <span class="text-danger">*</span></label>
        <select class="form-select" id="numeroBatidaAjuste" name="numeroBatidaAjuste" [(ngModel)]="numeroBatidaAjuste" required>
          <option [ngValue]="null" disabled>Selecione</option>
          <option [ngValue]="1">1</option>
          <option [ngValue]="2">2</option>
          <option [ngValue]="3">3</option>
          <option [ngValue]="4">4</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label" for="motivoAjuste">Motivo <span class="text-danger">*</span></label>
        <input class="form-control" id="motivoAjuste" type="text" name="motivoAjuste" [(ngModel)]="motivoAjuste" maxlength="50" required>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success w-100" [disabled]="formAjuste.invalid">Enviar</button>
      </div>
    </form>

    <div class="table-responsive" *ngIf="ajustes.length; else semAjustes">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Dia</th>
            <th>Horario</th>
            <th>Batida</th>
            <th>Motivo</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of ajustes">
            <td>{{ item.data }}</td>
            <td>{{ item.hora }}</td>
            <td>{{ item.numeroBatida }}</td>
            <td>{{ item.motivo }}</td>
            <td>{{ rotuloStatus(item.status) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #semAjustes>
      <p class="text-secondary mb-0">Nenhuma solicitacao de marcacao.</p>
    </ng-template>
  </section>

  <section class="panel p-4" *ngIf="aba === 'ferias'">
    <div class="mb-3">
      <h2 class="h5 mb-1">Solicitar Férias</h2>
      <div class="text-secondary small">{{ identificacao }}</div>
    </div>

    <form class="row g-3 align-items-end mb-4" (ngSubmit)="pedirFerias()">
      <div class="col-md-4">
        <label class="form-label" for="dataInicioFerias">Inicio</label>
        <input class="form-control" id="dataInicioFerias" type="date" name="dataInicioFerias" [(ngModel)]="dataInicioFerias" required>
      </div>
      <div class="col-md-4">
        <label class="form-label" for="dataFimFerias">Fim</label>
        <input class="form-control" id="dataFimFerias" type="date" name="dataFimFerias" [(ngModel)]="dataFimFerias" required>
      </div>
      <div class="col-md-4">
        <button class="btn btn-success">Enviar</button>
      </div>
    </form>

    <div class="table-responsive" *ngIf="ferias.length; else semFerias">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Protocolo</th>
            <th>Periodo</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of ferias">
            <td>{{ item.protocolo }}</td>
            <td>{{ item.dataInicio }} a {{ item.dataFim }}</td>
            <td>{{ rotuloStatus(item.status) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #semFerias>
      <p class="text-secondary mb-0">Nenhuma solicitacao de ferias.</p>
    </ng-template>
  </section>

  <section class="panel p-4" *ngIf="aba === 'oficio'">
    <div class="mb-3">
      <h2 class="h5 mb-1">Solicitar Número de Documento</h2>
      <div class="text-secondary small">{{ identificacao }}</div>
      <div class="text-secondary small">O numero do ano vigente e gravado com o seu usuario e departamento.</div>
    </div>

    <p class="text-secondary" *ngIf="!batidas?.podeOficios">Acesso nao liberado no cadastro do servidor.</p>

    <form class="row g-3 align-items-end mb-4" *ngIf="batidas?.podeOficios" (ngSubmit)="abrirModalFinalidade()">
      <div class="col-md-6">
        <label class="form-label" for="tipoDocumento">Tipo Documento</label>
        <select class="form-select" id="tipoDocumento" name="tipoDocumento" [(ngModel)]="tipoDocumento" required>
          <option [ngValue]="null">Selecione</option>
          <option value="OFICIO">Ofício</option>
          <option value="PORTARIA">Portaria</option>
          <option value="DECRETO">Decreto</option>
        </select>
      </div>
      <div class="col-md-3">
        <button class="btn btn-success w-100">Solicitar numero</button>
      </div>
    </form>

    <div class="table-responsive" *ngIf="documentos.length">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Data</th>
            <th>Tipo Documento</th>
            <th>Numero</th>
            <th>Ano</th>
            <th>Departamento do Servidor</th>
            <th>Finalidade</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of documentos">
            <td>{{ formatarData(item.dataSolicitacao) }}</td>
            <td>{{ rotuloTipo(item.tipo) }}</td>
            <td>{{ item.numero }}</td>
            <td>{{ item.ano }}</td>
            <td>{{ item.departamento || '—' }}</td>
            <td>{{ item.finalidade || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="panel p-4" *ngIf="aba === 'senha'">
    <div class="mb-3">
      <h2 class="h5 mb-1">Senha</h2>
      <div class="text-secondary small">Altere a senha do portal quando quiser.</div>
    </div>

    <form class="row g-3" (ngSubmit)="alterarSenha()">
      <div class="col-md-4">
        <label class="form-label" for="senhaAtual">Senha atual</label>
        <input class="form-control" id="senhaAtual" type="password" name="senhaAtual" [(ngModel)]="senhaAtual" autocomplete="current-password" required>
      </div>
      <div class="col-md-4">
        <label class="form-label" for="senhaNova">Nova senha</label>
        <input class="form-control" id="senhaNova" type="password" name="senhaNova" [(ngModel)]="senhaNova" autocomplete="new-password" required>
      </div>
      <div class="col-md-4">
        <label class="form-label" for="senhaConfirmacao">Confirmar senha</label>
        <input class="form-control" id="senhaConfirmacao" type="password" name="senhaConfirmacao" [(ngModel)]="senhaConfirmacao" autocomplete="new-password" required>
      </div>
      <div class="col-12">
        <button class="btn btn-success">Salvar senha</button>
      </div>
    </form>
  </section>

  <div *ngIf="modalFinalidadeAberta" class="modal-backdrop-custom" (click)="fecharModalFinalidade()">
    <div class="modal-card modal-card-finalidade" (click)="$event.stopPropagation()">
      <div class="modal-header-custom">
        <h3 class="h5 mb-0">Informe a finalidade</h3>
        <button type="button" class="btn btn-light btn-sm" (click)="fecharModalFinalidade()" aria-label="Fechar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <form class="modal-body-custom" (ngSubmit)="pedirDocumento()">
        <label class="form-label" for="finalidadeDocumento">Descreva a finalidade</label>
        <input
          class="form-control"
          id="finalidadeDocumento"
          type="text"
          name="finalidadeDocumento"
          maxlength="20"
          [(ngModel)]="finalidadeDocumento"
          required
          autofocus>
        <div class="form-text">Obrigatorio, no maximo 20 caracteres.</div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-secondary" (click)="fecharModalFinalidade()">Cancelar</button>
          <button type="submit" class="btn btn-success">Solicitar numero</button>
        </div>
      </form>
    </div>
  </div>
</app-layout-servidor>
